import React from 'react'
import {Row, Col} from 'antd'
import PropTypes from 'prop-types'
import {isEmpty} from 'lodash'

//Model
import MiningQuantity from "../../../models/miningQuantity";
// Components
import ViewTable from '../../Table/ViewTable'
import Button from '../../Buttons'
import RowTools from "../../Table/RowTools";
import MiningQuantityModal from "./modal";
import TableTitle from '../../Table/Title'
import helper from "../../../helper/helper";

// Columns
const columns_form = (showEditModal, deleteRowModal) => [
  {
    title: "#",
    dataIndex: "id",
    width: "45px",
  },
  {
    title: <TableTitle title="Công suât lắp máy" unit="(MW)"/>,
    dataIndex: "congSuatLapMay",
  },
  {
    title: <TableTitle title="Lưu lượng lớn nhất qua NMTĐ" unit="(m3/s)"/>,
    dataIndex: "luuLuongKhaiThacMax",
    width: "30%"
  },
  {
    title: <TableTitle title="Lưu lượng khai thác lớn nhất" unit="(m3/ngày.đêm)"/>,
    dataIndex: "luuLuongMaxQuaNMTD",
    width: "30%"
  },
  {
    title: "Thao tác",
    render: (value, row) => (
      <RowTools row={row} deleteRowModal={deleteRowModal} showEditModal={showEditModal}/>
    ),
    width: "80px"
  },
];

const columns_presentation = () => [
  {
    title: "#",
    dataIndex: "id",
    width: "45px",
  },
  {
    title: <TableTitle title="Công suât lắp máy" unit="(MW)"/>,
    dataIndex: "congSuatLapMay",
  },
  {
    title: <TableTitle title="Lưu lượng lớn nhất qua NMTĐ" unit="(m3/s)"/>,
    dataIndex: "luuLuongKhaiThacMax",
    width: "30%"
  },
  {
    title: <TableTitle title="Lưu lượng khai thác lớn nhất" unit="(m3/ngày.đêm)"/>,
    dataIndex: "luuLuongMaxQuaNMTD",
    width: "30%"
  },
];

export default class MiningQuantityForm extends React.PureComponent {
  constructor() {
    super();
    this.state = {
      isAddModalOpen: false,
      isEditModalOpen: false,
      miningQuantity: [],
      selectedRow: null
    }
  }

  handleOpenAddModal = () => {
    this.setState({
      isAddModalOpen: true
    })
  };

  handleOpenEditModal = (row) => {
    this.setState({
      selectedRow: row,
      isEditModalOpen: true
    })
  };

  handleCloseModal = () => {
    this.setState({
      isAddModalOpen: false,
      isEditModalOpen: false,
      selectedRow: null
    })
  };

  handleAddWorkItem = (item) => {
    const {dataSource, handleUpdate} = this.props;
    const newData = [{...new MiningQuantity(item), id: dataSource.length + 1}, ...dataSource];
    handleUpdate(newData);
    this.handleCloseModal();
  };

  handleEditItem = (item) => {
    const {dataSource, handleUpdate} = this.props;
    const newData = helper.replaceItem(item, dataSource);
    handleUpdate(newData);
    this.handleCloseModal();
  };

  handleDeleteItem = (item) => {
    const {dataSource, handleUpdate} = this.props;
    const newData = helper.removeItem(item, dataSource);
    handleUpdate(newData);
  };

  render() {
    const {isAddModalOpen, isEditModalOpen, selectedRow} = this.state;
    const {dataSource, mode} = this.props;
    return (
      <Row>
        <Row type="flex" justify="end" align="middle">
          {mode !== "presentation" && <Button type="primary" onClick={this.handleOpenAddModal} icon="plus"/>}
        </Row>
        <div className="mt-10"/>
        <ViewTable
          pagination={false}
          columns={mode !== "presentation" ? columns_form(this.handleOpenEditModal, this.handleDeleteItem) : columns_presentation()}
          dataSource={dataSource} onChange={(...param) => console.log(param)}/>
        <MiningQuantityModal
          mode="add"
          isOpen={isAddModalOpen}
          handleCancel={this.handleCloseModal}
          handleOk={this.handleAddWorkItem}/>
        <MiningQuantityModal
          mode="edit"
          initialValues={selectedRow}
          isOpen={isEditModalOpen}
          handleCancel={this.handleCloseModal}
          handleOk={this.handleEditItem}/>
      </Row>
    )
  }
}

MiningQuantityForm.propTypes = {
  mode: PropTypes.string.isRequired,
  handleUpdate: PropTypes.func,
  dataSource: PropTypes.array.isRequired
};